var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"radio","name":_vm.name,"id":_vm.id},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.updateValue({
    objectType: _vm.objectType,
    objectId  : _vm.objectId,
    key       : _vm.propertyKey,
    value     : _vm.value,
    index     : _vm.index
  })}}})}
var staticRenderFns = []

export { render, staticRenderFns }